import * as React from 'react';
import { Customer } from 'types/Customer';
import { ControlledAssignButton } from '../customer-tag/ControlledAssignButton';

import { ColumnMappingTable, UploadedFileColumn } from './column-mapping';

interface Props {
  columns: UploadedFileColumn[];
  setColumns: (columns: UploadedFileColumn[]) => void;
  customer: Customer | null;
  setCustomer: (customer: Customer | null) => void;
}

/**
 * For the case where customer id is not detected
 */
export const MultipleColumns: React.FC<Props> = (props) => {
  const { columns, setColumns, setCustomer } = props;

  const [assignmentButtonOpen, setAssignmentIsOpen] = React.useState(false);
  const handleOnSelect = (customer: Customer | null, close?: boolean) => {
    setCustomer(customer);
    if (close) {
      setAssignmentIsOpen(false);
    }
  };

  return (
    <div className="space-y-8">
      <div className="space-y-2">
        <h4 className="font-bold">
          Option 1 - Pick a column from your file to assign as Reference ID:
        </h4>
        <ColumnMappingTable columns={columns} setColumns={setColumns} />
      </div>
      <div className="space-y-2">
        <h4 className="font-bold">
          Option 2 - Add or create new Reference ID to apply to all containers:
        </h4>
        <ControlledAssignButton
          setCustomer={handleOnSelect}
          customer={props.customer}
          setIsOpen={setAssignmentIsOpen}
          isOpen={assignmentButtonOpen}
          className="sticky"
        />
      </div>
    </div>
  );
};
MultipleColumns.displayName = 'CustomerAssignment.MultipleColumns';
